import React from 'react'

import { Box } from '@gousto-internal/citrus-react'
import { DeviceType, useDeviceType } from '@library/dom'

import { Carousel, type CarouselProps } from '../../EndlessVarietySection/Carousel'
import { LandingPageContentSections } from '../../../tracking'
import { CWC_HOW_IT_WORKS_SECTION, isVideoStep } from '../config'
import { CWCHowItWorksStaticCard } from './CWCHowItWorksStaticCard'
import { CWCHowItWorksStepCard } from './CWCHowItWorksStepCard'

const propertiesForTracking = {
  carouselSection: LandingPageContentSections.HOW_RECIPE_BOXES_WORK,
}

export const CWCHowItWorksCarousel = () => {
  const deviceType = useDeviceType()
  const isDesktopDevice = deviceType === DeviceType.DESKTOP

  // Desktop shows all four cards in a static centred row (no arrows); tablet/mobile overflow into a
  // horizontal-scroll carousel — matching the Reviews Section pattern.
  const carouselOptions: CarouselProps['options'] = isDesktopDevice
    ? { align: 'center', containScroll: 'trimSnaps', loop: false }
    : { align: 'start', loop: false }

  return (
    <Box data-testid="how-it-works-carousel">
      <Carousel
        carouselAreaLabel="howItWorksCarousel"
        options={carouselOptions}
        slidePaddingH={2}
        slidePaddingV={1}
        showNavButtons={false}
        centerSlidesWhenNotScrollable={isDesktopDevice}
        snowplowTrackingProperties={propertiesForTracking}
      >
        {CWC_HOW_IT_WORKS_SECTION.steps.map((step) =>
          isVideoStep(step) ? (
            <CWCHowItWorksStepCard
              key={step.tile}
              stepNumber={step.stepNumber}
              title={step.title}
              body={step.body}
              videoURL={step.videoURL}
              tile={step.tile}
            />
          ) : (
            <CWCHowItWorksStaticCard
              key={step.title}
              stepNumber={step.stepNumber}
              title={step.title}
              body={step.body}
            />
          ),
        )}
      </Carousel>
    </Box>
  )
}
